import { baseResources, baseResourceActions } from "routes/enum";

const { KB_LLM_DOCUMENT, KB_LLM_CHAT } = baseResources;
const { READ, CREATE, UPDATE, DELETE } = baseResourceActions;

/** View LLM documentation */
export const LLM_DOCUMENTATION_READ_PERMISSION = [
    `${READ}_${KB_LLM_DOCUMENT}`,
];

/** Create LLM document */
export const LLM_DOCUMENT_CREATE_PERMISSION = [
    `${CREATE}_${KB_LLM_DOCUMENT}`,
];

/** Edit LLM document */
export const LLM_DOCUMENT_UPDATE_PERMISSION = [
    `${UPDATE}_${KB_LLM_DOCUMENT}`,
];

/** Delete LLM document */
export const LLM_DOCUMENT_DELETE_PERMISSION = [
    `${DELETE}_${KB_LLM_DOCUMENT}`,
];

/** View LLM chat */
export const LLM_CHAT_READ_PERMISSION = [`${READ}_${KB_LLM_CHAT}`];

export const LLM_DOCUMENT_WRITE_PERMISSION = [
    ...LLM_DOCUMENT_CREATE_PERMISSION,
    ...LLM_DOCUMENT_UPDATE_PERMISSION,
];

export const LLM_DOCUMENTATION_PERMISSION_MAP = {
    "View LLM documentation": LLM_DOCUMENTATION_READ_PERMISSION,
    "Create LLM document": LLM_DOCUMENT_CREATE_PERMISSION,
    "Edit LLM document": LLM_DOCUMENT_UPDATE_PERMISSION,
    "Delete LLM document": LLM_DOCUMENT_DELETE_PERMISSION,
    "View LLM chat": LLM_CHAT_READ_PERMISSION,
};
